export default (function (map, ids, type) {
  return ids.map(function (id) {
    if (!map[id]) {
      throw new ReferenceError("no ".concat(type, " with id \"").concat(id, "\" found"));
    }
    return map[id];
  });
});